module.exports = __webpack_public_path__ + "static/media/Ø1_1.e93c6236.png";